module.exports = __webpack_public_path__ + "media/images/ic-people-menu-4c97749096e0ba968450818472fb8417.svg";